import { NORMALISED_CARB_SWAP_SET } from "@/features/meal-plan/constants/carb-swap";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";
import { CarbSwapTag } from "./carb-swap-tag";

interface MealDetailTagsProps {
  categoryPills?: string[];
}

export const MealDetailTags = memo(function MealDetailTags({ categoryPills }: MealDetailTagsProps) {
  if (!categoryPills || categoryPills.length === 0) {
    return null;
  }

  return (
    <>
      <div className="flex flex-wrap items-center justify-center gap-3">
        {categoryPills.map((pill, index) => {
          const isCarbSwap = NORMALISED_CARB_SWAP_SET.has(pill.toLowerCase().trim());

          if (isCarbSwap) {
            return <CarbSwapTag key={`${pill}-${index}`} label={pill} />;
          }

          return (
            <span
              key={`${pill}-${index}`}
              className={cn(
                textVariants.bodySmall,
                "flex h-9 items-center rounded-full bg-[#F9EDFF] px-4 py-2 capitalize",
              )}
            >
              {pill}
            </span>
          );
        })}
      </div>
    </>
  );
});
